(() => {
  if (window.pooleaseSeoEventsInstalled) return;
  window.pooleaseSeoEventsInstalled = true;
  const models = new Map([
    ['poolease-x1-dark-blue-purple', 'X1'],
    ['poolease-x1a-dark-blue', 'X1A'],
    ['poolease-s1-blue', 'S1'],
  ]);
  const send = (name, parameters) => {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof window.gtag !== 'function') return;
      window.gtag('event', name, { ...parameters, send_to: 'G-S44EDB8G6B' });
    } catch { /* Analytics must never interrupt navigation. */ }
  };
  document.addEventListener('click', event => {
    if (event.button > 0) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let destination;
    try { destination = new URL(link.href, location.href); } catch { return; }
    const support = link.closest('[data-support-product]');
    const model = support?.id?.replace('support-model-', '').toUpperCase();
    if (link.matches('[data-support-model-link]')) {
      const selected = destination.hash.replace('#support-model-', '').toUpperCase();
      if (['X1', 'X1A', 'S1'].includes(selected)) send('support_model_select', { model: selected, placement: 'support_navigation' });
    } else if (link.matches('.support-document__link') && /\.pdf$/i.test(destination.pathname)) {
      const document = link.closest('[data-support-document]');
      send('manual_download', { model, document_type: document?.dataset.documentType || '', version: document?.dataset.documentVersion || '', region: document?.dataset.documentRegion || '' });
    } else if (destination.origin === location.origin) {
      const handle = destination.pathname.split('/products/')[1];
      if (models.has(handle) && link.closest('[data-model-picker], .product-card')) {
        send('collection_product_click', { model: link.closest('[data-comparison-model]')?.dataset.comparisonModel || models.get(handle), target_handle: handle, variant_id: destination.searchParams.get('variant') || '', placement: link.closest('[data-comparison-model]') ? 'comparison' : 'product_card' });
      } else if (!event.defaultPrevented && models.has(handle) && link.closest('.review-hub-header, .review-customer-feedback')) {
        send('review_product_click', { model: models.get(handle), target_handle: handle, source_key: 'review_hub' });
      } else if (destination.pathname === '/collections/pool-cleaner' && link.closest('.article-page__body')) {
        send('article_collection_click', { article_path: location.pathname, placement: 'body' });
      } else if (destination.pathname === '/pages/support' || (location.pathname === '/pages/support' && destination.pathname === '/pages/contact')) {
        send('support_help_click', { model: destination.hash.replace('#support-model-', '').toUpperCase() || model || '', destination_type: destination.pathname === '/pages/contact' ? 'contact' : 'support' });
      }
    }
  });
})();
